var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.visibleContents),function(content,index){return _c('div',{key:'content'+index},[(content.imgPath)?_c('ContentImage',{key:index,attrs:{"imgSrc":content.imgPath},on:{"imageInit":_vm.nextContent}}):(content.giphy)?_c('ContentGiphy',{attrs:{"giphy":content.giphy},on:{"giphyInit":_vm.nextContent}}):(content.copy)?_c('Typewriter',{staticClass:"paragraph",class:[
        { ['paragraph--' + content.color] : content.color },
        'paragraph--' + content.size
      ],attrs:{"text":content.copy,"speed":15,"pre-type-delay":500},on:{"typed-line":_vm.onLineTyped,"complete":_vm.nextContent}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Content.vue?vue&type=template&id=73a396e2&
// module id = null
// module chunks = 